<div class="auth-page-logout spinner block mt-9 m-auto"></div>
